import React, { useEffect, useState, useContext } from 'react';
import { back } from '../../helpers/dataServer';
import { UserContext } from '../auth/context/UserContext';

export const ListPerfilesNuevoUser = ({
  usuarioPerfil,
  onPerfilChange,
  //modoMultiple = false,
  modoMultiple,
}) => {
  const { dataUser } = useContext(UserContext);
  const [perfiles, setPerfiles] = useState([]);
  const { token } = dataUser;

  useEffect(() => {
    fetch(`${back}/perfiles/listperfiles`, {
      headers: {
        Authorization: token,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((data) => setPerfiles(data.data))
      .catch((error) =>
        console.error('Error al obtener la lista de perfiles:', error)
      );
  }, [token]);

  const handlePerfilChange = (perfilId) => {
    if (modoMultiple) {
      const perfilesSeleccionados = Array.isArray(usuarioPerfil)
        ? usuarioPerfil
        : [];
      onPerfilChange(
        perfilesSeleccionados.includes(perfilId)
          ? perfilesSeleccionados.filter((id) => id !== perfilId)
          : [...perfilesSeleccionados, perfilId]
      );
    } else {
      onPerfilChange(perfilId);
    }
  };

  return (
    <div className="selectPerfil">
      {perfiles.map((perfil) => (
        <div key={perfil.id}>
          <input
            type="checkbox"
            id={`cbox-${perfil.id}`}
            value={perfil.id}
            checked={
              modoMultiple
                ? usuarioPerfil?.includes(perfil.id)
                : usuarioPerfil === perfil.id
            }
            onChange={() => handlePerfilChange(perfil.id)}
          />
          <label htmlFor={`cbox-${perfil.id}`}>{perfil.denominacion}</label>
          <hr />
        </div>
      ))}
    </div>
  );
};
